import {
    FAILURE_EXPERTS,
    REQUEST_EXPERTS_WITH_FILTER,
    RESPONSE_EXPERTS_WITH_FILTER
} from '../../actions/types';
import { EXPERTS_SEARCH_API } from '../../constants/_api';
import query from './query';
import asyncActionErrorHandler from '../../utils/asyncActionErrorHandler';

const dispatchRequest = (dispatch, payload) => dispatch({
    type: REQUEST_EXPERTS_WITH_FILTER,
    payload
});

const dispatchResponse = (dispatch, payload) => dispatch({
    type: RESPONSE_EXPERTS_WITH_FILTER,
    payload
});

const dispatchFailure = (dispatch) => dispatch({
    type: FAILURE_EXPERTS
});

export const getExpertsWithFilter = (keyword, country, year, token) => asyncActionErrorHandler(async (dispatch) => {
    
    if (!keyword) {
        return
    }

    dispatchRequest(dispatch, { country, year, keyword });
    
    if(Array.isArray(country)){
        
        country = country.map(l => l.value);
        country = country.join(',');

    }


    let url = `${EXPERTS_SEARCH_API}?q=${keyword}&country=${country}&year=${year}`;

    if (year == 'All' && country == 'All') {
        url = `${EXPERTS_SEARCH_API}?q=${keyword}`
    } else if (country == 'All') {
        url = `${EXPERTS_SEARCH_API}?q=${keyword}&year=${year}`
    } else if (year == 'All') {
        url = `${EXPERTS_SEARCH_API}?q=${keyword}&country=${country}`
    }

    let result = await query(url, token);
    result = await result.json();
    result.keyword = keyword;
    result.body.statusCode = result.statusCode;

    if (result.message === 'SUCCESS') {
        dispatchResponse(dispatch, result.body);
    } else {
        dispatchFailure(dispatch);
    }

}, dispatchFailure);
